export default function (
  callback: () => Promise<false | undefined>,
): Ref<boolean> {
  const spinner = useSpinner()
  const isPreloading = ref(true)

  // preload function
  const preload = async () => {
    let callbackResult

    try {
      callbackResult = await callback()
    } catch (error) {
      console.error('Callback failed in preloader:', error)
      callbackResult = false
    }

    setTimeout(() => {
      isPreloading.value = callbackResult === false ? true : false
    }, 1)
  }

  // preload
  spinner(async () => await preload(), 1000)

  // return status
  return isPreloading
}
